export const ECRITURE_LOCK_LABELS = {
    closedPeriod: 'exercice clôturé',
    validated: 'écriture validée',
    reconciled: 'écriture pointée',
    lettered: 'écriture lettrée',
    unattributed: 'compte partagé, écriture non rattachée à ce tiers',
};
/** For the confirmation of a change that rewrites écritures. */
export const KEPT_ECRITURES_RULE = "Les écritures d'un exercice clôturé, validées, pointées ou lettrées ne sont pas modifiées : elles restent en l'état et sont signalées.";
export const NO_REWRITE = { movedEntriesCount: 0, keptEntries: [] };
export const mergeRewrites = (...rewrites) => ({
    movedEntriesCount: rewrites.reduce((sum, rewrite) => sum + rewrite.movedEntriesCount, 0),
    keptEntries: rewrites.flatMap((rewrite) => rewrite.keptEntries),
});
